import React, { useState } from 'react';
import './App.css';
import TaskForm from './components/TaskForm';
import TaskList from './components/TaskList';

function App() {
  // Estado principal: lista de tareas
  const [tasks, setTasks] = useState([
    // Ejemplo opcional para probar:
    // { id: 1, text: 'Comprar pa', completed: false, dueDate: null },
    // { id: 2, text: 'Estudiar React', completed: true, dueDate: new Date().toISOString() },
  ]);

  // Añadir nueva tarea (recibe el texto desde TaskForm)
  const handleAddTask = (text) => {
    const task = {
      id: Date.now(),
      text: text,
      completed: false,
      dueDate: null, // campo para la Millora 3 (selector de fecha)
    };
    setTasks([...tasks, task]);
  };

  // Marcar/desmarcar tarea como completada
  const handleToggleComplete = (taskId) => {
    setTasks(
      tasks.map((task) =>
        task.id === taskId ? { ...task, completed: !task.completed } : task
      )
    );
  };

  // Eliminar tarea
  const handleDeleteTask = (taskId) => {
    setTasks(tasks.filter((task) => task.id !== taskId));
  };

  // Actualizar fecha de vencimiento
  const handleUpdateTaskDate = (taskId, newDate) => {
    setTasks(
      tasks.map((task) =>
        task.id === taskId
          ? { ...task, dueDate: newDate ? newDate.toISOString() : null }
          : task
      )
    );
  };

  return (
    <div className="app-container">
      <div className="todo-container">
        <h1>La Meva Llista de Tasques</h1>
        <h2>Manuel Marcano</h2>

        {/* Formulario para añadir nueva tarea */}
        <TaskForm onAddTask={handleAddTask} />

        {/* Lista de tareas con sus acciones */}
        <TaskList
          tasks={tasks}
          onToggleComplete={handleToggleComplete}
          onDeleteTask={handleDeleteTask}
          onUpdateTaskDate={handleUpdateTaskDate}
        />
      </div>
    </div>
  );
}

export default App;
